import React from 'react';

import type { ComponentPropsWithoutRef } from '@rtkwlf/fenrir-react';
import { Primitive, Text } from '@rtkwlf/fenrir-react';
import type { AttachmentFile } from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';

import { scaleValue } from '@packages/utils/base.utils';

export interface TicketAttachmentsProps
  extends ComponentPropsWithoutRef<typeof Primitive.div> {
  attachments?: Array<AttachmentFile>;
}

export const TicketAttachments = ({
  attachments = [],
  ...rest
}: TicketAttachmentsProps) => {
  const { t } = useTranslation();

  if (!attachments.length) return null;

  return (
    <Primitive.div
      display="flex"
      flexDirection="column"
      maxHeight="14rem"
      overflow="scroll"
      css={{
        '::-webkit-scrollbar-corner': { backgroundColor: 'transparent' },
      }}
      {...rest}
    >
      {attachments.map(({ id, url, name, size = '' }) => {
        if (!url) return undefined;
        const { num, suffix } = scaleValue(size, 1024, 0, t);

        return (
          url && (
            <Primitive.a
              backgroundColor="widgetHighlight"
              padding="smedium"
              cursor="pointer"
              width="full"
              key={id}
              display="flex"
              gap="xsmall"
              href={url}
              download={name}
              target="_blank"
              textDecoration="none"
            >
              <Text
                styledAs="custom"
                textColor="body"
                fontWeight="bold"
                wordBreak="break-word"
                fontSize="small"
              >
                {name}
                <Primitive.span>{` (${num}${suffix})`}</Primitive.span>
              </Text>
            </Primitive.a>
          )
        );
      })}
    </Primitive.div>
  );
};
